/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryErrorHandler, querySuccessHandler, queryDeleteSuccessHandler } from '../../queryStateHandlers';
import { UpsertTypeEnum } from '../../../../@types/enum/upsertType';
import { IDamConstructionTypeUpsert } from '../../../../@types/modelV2/masterData/dam/damConstructionType/damConstructionTypeUpsert';
import { IDamConstructionType } from '../../../../@types/modelV2/masterData/dam/damConstructionType/damConstructionType';
import { DELETE_DAM_CONSTRUCTION_TYPE_KEY, GET_DAM_CONSTRUCTION_TYPES_KEY, UPSERT_DAM_CONSTRUCTION_TYPE_KEY } from '../../queryConstants';
import DamConstructionTypeHttpService from '../../../../services/dam/damConstructionTypeHttpService';

export const useGetDamConstructionTypes = () => {
    const query = useQuery<Array<IDamConstructionType>, Error>({
        queryKey: [GET_DAM_CONSTRUCTION_TYPES_KEY],
        queryFn: () => DamConstructionTypeHttpService.getList(),
        onError: queryErrorHandler('Error loading Dam Construction Type.'),
    });

    return query;
};

export const useHandleUpsertDamConstructionType = () => {
    const result = useMutation<IDamConstructionType, Error, { upsert : IDamConstructionTypeUpsert; type : UpsertTypeEnum }>({
        mutationKey: [UPSERT_DAM_CONSTRUCTION_TYPE_KEY],
        mutationFn: (args : { upsert : IDamConstructionTypeUpsert; type : UpsertTypeEnum }) => DamConstructionTypeHttpService.upsert(args.upsert, args.type),
        onError: queryErrorHandler('Error creating/updating Dam Construction Type.'),
        onSuccess: querySuccessHandler(GET_DAM_CONSTRUCTION_TYPES_KEY, 'Dam Construction Type updated successfully.')
    });

    return result;
};

export const useHandleDeleteDamConstructionType = () => {
    return useMutation<void, Error, number>({
        mutationKey: [DELETE_DAM_CONSTRUCTION_TYPE_KEY],
        mutationFn: (contactUsId : number) => DamConstructionTypeHttpService.delete(contactUsId),
        onError: queryErrorHandler('Error deleting Dam Construction Type.'),
        onSuccess: queryDeleteSuccessHandler(DELETE_DAM_CONSTRUCTION_TYPE_KEY, GET_DAM_CONSTRUCTION_TYPES_KEY, 'Dam Construction Type inactivated successfully.')
    });
};
